import React from "react";
import style from "./spinner.module.css";

export function Spinner() {
  return <div className={style.loader} />;
}
